// extracted by mini-css-extract-plugin
module.exports = {"label-input":"v-input-money_label-input_3hOgO","large-space":"v-input-money_large-space_20RlF","disabled":"v-input-money_disabled_3NLU6"};